import { css } from '@emotion/react';
import colors from '../../../Themes/colors';
import fonts from '../../../Themes/fonts';

export const variationOption = css({
    // width: '10rem',
    height: 'fit-content',
    border: '2px solid #bebebe',
    padding: '0.5rem 1rem',
    fontSize: '1rem',
    borderRadius: '8px',

    '> p': {
        fontSize: '1.2rem',
        margin: 0,
    },
});

export const quantityContainer = css({
    '@media(min-width:300px)': {
        display: 'flex',
        alignItems: 'center',
        gap: 40,
        paddingTop: 40,
        paddingBottom: 20,

        '& p': {
            margin: 0,
            fontFamily: 'AcuminRPro',
        },
        '& div': {
            '& button': {
                margin: 0,
            },
        },
    },
    '@media(min-width:1200px)': {
        display: 'flex',
        alignItems: 'center',
        gap: 40,
        paddingTop: 40,

        '& p': {
            margin: 0,
            fontFamily: 'AcuminRPro',
        },
        '& div': {
            '& button': {
                margin: 0,
            },
        },
    },

});

export const variantContainer = css({
    display: 'flex',
    gap: 20,

    '& div': {
        '& button': {
            margin: 0,
        },
    },
});

export const variantDetailsContainer = css({
    '@media(min-width:300px)': {
        display: 'grid',
        gridTemplateColumns: 'auto auto auto',
        gap: 8,
        padding: '1rem',
        overflow: 'auto',
        scrollBehavior: 'smooth',

        '& .selected': {
            border: '2px solid #064E72',
        },
    },
    '@media(min-width:1200px)': {
        gridTemplateColumns: 'auto auto auto auto auto',
    },
});

export const shareContainer = css({
    '@media(min-width:300px)': {
        display: 'flex',
        gap: 20,
        paddingTop: 40,

        '& p': {
            fontWeight: 'bold',
            fontSize: '1.6rem',
            // textAlign: 'center',
            letterSpacing: 1,
            transform: 'scale(1, 0.9)',
            margin: 0,
        },

        '& div': {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            '& img': {
                width: 20,
                height: 20,
            },
        },
    },

});

export const buttonContainer = css({
    '@media(min-width:300px)': {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& div': {
            width: '100%',
        },
    },
    '@media(min-width:1200px)': {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'start',
        gap: 20,
        paddingTop: 40,
        '& div': {
            width: 'auto',
        },
    },
});

export const productDetailsContainer = css({
    padding: '0px 20px',

    '@media(min-width:576px)': {
        padding: '0px 40px',
    },

    '@media(min-width:992px)': {
        padding: '30px 80px',
    },

    '@media(min-width:1200px)': {
        padding: '0px 120px',
    },

    '@media(min-width:1500px)': {
        padding: '0px 120px',
    },
});

export const productImgContainer = css({
    textAlign: 'center',
    padding: '10px 0px 0px',
});

export const productImg = css({
    '@media(min-width:300px)': {
    },
    '@media(min-width:1200px)': {
        width: '80%',
        border: '1px solid #E6DFD8',

        '& .iiz__img': {
            width: '100%',
            height: 500,
            objectFit: 'contain',
        },
    },

});

export const productCarousel = css({

    '@media(min-width:300px)': {
        padding: '10px 20px',
        '& .BrainhubCarousel__arrows': {
            backgroundColor: colors.white,
            span: {
                borderColor: colors.black,
            },
            '&:hover': {
                backgroundColor: colors.white,
                span: {
                    borderColor: colors.black,
                },
            },
            '&:disabled': {
                span: {
                    borderColor: colors.gray,
                },
            },
        },
    },
    '@media(min-width:1200px)': {
        padding: '10px 20px',
        '& .BrainhubCarousel__arrows': {
            backgroundColor: colors.white,
            span: {
                borderColor: colors.black,
            },
            '&:hover': {
                backgroundColor: colors.white,
                span: {
                    borderColor: colors.black,
                },
            },
            '&:disabled': {
                span: {
                    borderColor: colors.gray,
                },
            },
        },
    },

});

export const productImgCarousel = css({
    height: 100,
    width: '100%',
    objectFit: 'contain',

    '&:hover': {
        border: '1px solid black',
    },
});

export const productName = css({
    // font: '35px Archivo-Medium, sans-serif',
    // color: colors.black,
    // marginTop: '20px',
    // fontSize: '30px',

    fontWeight: 'bold',
    fontSize: '3rem',
    letterSpacing: 2,
    transform: 'scale(1, 0.9)',

    '@media(min-width:768px)': {
        marginTop: '0px',
        fontSize: '35px',
    },
});

export const productPurityText = css({
    ...fonts.productNoteText,
    color: colors.primary,
});

export const productRatingRow = css({
    marginTop: '1.2rem',
    marginBottom: '1.2rem',
});

export const productRatingText = css({
    ...fonts.productRatingText,
    color: colors.black,
    marginLeft: '10px',
});

export const productRatingStars = css({
    width: '20px',
    height: '20px',

    '@media(min-width:576px)': {
        width: '24px',
        height: '24px',
    },
});

export const productPrice = css({
    // ...fonts.productPriceText,
    // color: colors.primary,
    // marginTop: '1.2rem',
    // fontSize: '20px',

    paddingTop: 10,
    fontWeight: 'bold',
    fontSize: '3rem',
    letterSpacing: 1,
    transform: 'scale(1, 0.9)',

    '@media(min-width:992px)': {
        fontSize: '25px',
    },
});

export const productLaborChargeMsg = css({
    font: '1.2rem Archivo-Regular, sans-serif',
    color: '#616161',
    marginTop: 5,
    paddingTop: 10,
});

export const productDetailsText = css({
    width: '15rem',
    font: '20px Playfair, sans-serif',
    color: colors.black,
    // marginTop: '1.2em',
    fontWeight: 700,
    // alignItems: 'start',
    // display: 'flex',
    letterSpacing: 1,
    transform: 'scale(1, 0.9)',

    '@media(min-width:992px)': {
        fontSize: '20px',
    },
});

export const productVariationText = css({
    font: '1.4rem Archivo-Regular, sans-serif',
    color: colors.black,
    padding: '5px 20px',
});

export const productDropdown = css({
    // marginTop: '0.6em',
    font: '16px AcuminRPro, sans-serif',
    color: '#B7916A',
    backgroundColor: colors.white,
    borderColor: '#E6DFD8',
    paddingTop: 15,
    paddingBottom: 10,
    paddingLeft: 15,
    paddingRight: 15,
    '&:hover,&:focus': {
        color: '#064E72',
        backgroundColor: colors.white,
        borderColor: '#064E72',
    },
});

export const addToCartButtonContainer = css({
    display: 'flex',
    height: 140,
    alignItems: 'center',
    justifyContent: 'center',
});

export const addToCartButton = css({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '18px AcuminRPro',
    fontSize: '16px',
    color: 'white',
    backgroundColor: '#064E72',
    // border: `2px solid ${colors.black}`,
    borderRadius: '12px',
    height: 65,
    width: '100%',
    padding: '6px',
    marginTop: '1.2rem',
    transition: 'ease 0.2s',
    '&:hover,&:focus': {
        border: '2px solid #064E72',
        backgroundColor: colors.white,
        fill: colors.white,
        color: '#064E72',

        '& .cartBlue': {
            display: 'block',
            width: '25px',
            height: '25px',
            marginLeft: '15px',

            '@media(min-width:992px)': {
                width: '25px',
                height: '25px',
                marginTop: -5,
            },
        },
        '& .cart': {
            display: 'none',
        },
    },

    '& .cartBlue': {
        display: 'none',
    },
    '& .cart': {
        display: 'block',
        width: '25px',
        height: '25px',
        marginLeft: '15px',

        '@media(min-width:992px)': {
            width: '25px',
            height: '25px',
            marginTop: -5,
        },
    },

    '@media(min-width:992px)': {
        width: 220,
        fontSize: '18px',
    },
});

export const buttonIcons = css({
    width: '25px',
    height: '25px',
    marginLeft: '15px',
    color: 'unset',

    '@media(min-width:992px)': {
        width: '25px',
        height: '25px',
        marginTop: -5,
    },
});

export const checkoutButton = css({

    display: 'block',
    font: '18px AcuminRPro',
    fontSize: '16px',
    color: '#064E72',
    backgroundColor: 'white',
    border: '2px solid #064E72',
    borderRadius: '12px',
    width: '100%',
    height: 65,
    // padding: '6px',
    marginTop: '1.2rem',
    transition: 'ease 0.2s',
    fill: colors.white,

    '& svg': {
        color: 'transparent',
        fill: 'transparent',
    },

    '&:hover svg': {
        color: '#064E72',
        fill: '#064E72',
    },
    '&:hover': {
        border: '2px solid #E6DFD8',
        backgroundColor: '#BCBEC0',
        color: '#064E72',
    },
    '&:focus': {
        color: '#064E72',
        backgroundColor: colors.white,
        border: '2px solid #E6DFD8',
    },
    '&:active': {
        color: '#064E72',
        backgroundColor: colors.white,
        border: '2px solid #E6DFD8',
    },

    '@media(min-width:992px)': {
        width: 260,
        fontSize: '18px',
    },
});

export const checkoutButtonLoading = css({
    display: 'block',
    font: '18px Archivo-Regular, sans-serif',
    fontSize: '16px',
    color: colors.white,
    backgroundColor: colors.white,
    border: '2px solid #064E72',
    borderRadius: '3px',
    width: '220px',
    padding: '6px',
    height: 45,
    marginTop: '1.2rem',
    transition: 'ease 0.2s',
    fill: colors.white,

    '&:hover,&:focus': {
        border: '2px solid #064E72',
        backgroundColor: colors.white,
        fill: colors.white,
        color: '#064E72',
    },
    '&:active': {
        border: '2px solid #064E72',
    },
    '@media(min-width:992px)': {
        width: '300px',
        fontSize: '18px',
    },
});

export const wishlistButton = css({
    font: '20px Archivo-Regular, sans-serif',
    color: colors.black,
    marginTop: '1.2em',
    fontSize: '18px',
    alignItems: 'center',
    display: 'flex',
    fill: colors.black,
    '&:hover': {
        fill: colors.red,
    },
    '&:focus': {
        fill: colors.red,
    },
    '&:active': {
        fill: colors.red,
    },

    '@media(min-width:992px)': {
        fontSize: '20px',
    },
});

export const filledWishlistButton = css({
    font: '20px Archivo-Regular, sans-serif',
    color: colors.black,
    marginTop: '1.2em',
    fontSize: '18px',
    alignItems: 'center',
    display: 'flex',
    fill: colors.red,

    '@media(min-width:992px)': {
        fontSize: '20px',
    },
});

export const productNoteText = css({
    ...fonts.productNoteText,
    color: colors.gray,
    marginTop: '1.2em',
    fontSize: '13px',

    '@media(min-width:992px)': {
        fontSize: '14px',
    },
});

export const productDescriptionTitle = css({
    ...fonts.productDescriptionTitle,
    color: colors.black,
});

export const productDescription = css({
    ...fonts.productDescriptionText,
    color: colors.black,
    marginTop: '1.2em',
});

export const similarItemsContainer = css({
    padding: '0px 20px',

    '@media(min-width:576px)': {
        padding: '10px 40px',
    },

    '@media(min-width:992px)': {
        padding: '20px 60px',
    },

    '@media(min-width:1200px)': {
        padding: '20px 150px',
    },

    '@media(min-width:1500px)': {
        padding: '20px 300px',
    },
});

export const similarItemsTitle = css({
    ...fonts.similarItemsTitle,
    color: colors.black,
    textAlign: 'center',
    margin: '30px 0px 0px',

    '@media(min-width:576px)': {
        margin: '30px 0px',
    },
});

export const similarItemsCarousel = css({
    padding: '0px',
    '& .BrainhubCarousel__arrows': {
        backgroundColor: colors.white,
        span: {
            borderColor: colors.black,
            height: '10px',
            width: '10px',
        },
        '&:hover': {
            backgroundColor: colors.white,
            span: {
                borderColor: colors.black,
            },
        },
        '&:disabled': {
            span: {
                borderColor: colors.gray,
            },
        },

        '@media(min-width:576px)': {
            height: '30px',
            width: '30px',
        },
    },

    '@media(min-width:576px)': {
        padding: '10px 20px',
    },
});

export const productReviewsTitle = css({
    ...fonts.productReviewsTitle,
    color: colors.black,
    marginTop: '1.2em',
});

export const productReviewsContainer = css({
    padding: '0px 20px',

    '@media(min-width:576px)': {
        padding: '10px 40px',
    },

    '@media(min-width:992px)': {
        padding: '20px 60px',
    },

    '@media(min-width:1200px)': {
        padding: '20px 150px',
    },

    '@media(min-width:1500px)': {
        padding: '20px 300px',
    },
});

export const productReviewsCount = css({
    productRatingText,
    color: colors.gray,
    marginLeft: '10px',
});

export const reviewImg = css({
    width: '80%',
    borderRadius: '50%',
});

export const reviewAuthor = css({
    ...fonts.productReviewAuthor,
    color: colors.black,
});

export const reviewDate = css({
    ...fonts.productReviewDate,
    color: colors.gray,
});

export const reviewDescription = css({
    ...fonts.productDescriptionText,
    color: colors.black,
    marginTop: '1.2em',
});

export const reviewVariation = css({
    ...fonts.productNoteText,
    color: colors.gray,
    marginTop: '1.2em',
});

export const reviewLoadMoreButton = css({
    font: '18px Archivo-Regular, sans-serif',
    color: colors.primary,
    backgroundColor: colors.lightbrown,
    border: '0px',
    borderRadius: '3px',
    padding: '12px 15px',
    margin: '25px 0px',
    transition: 'ease 0.2s',
    '&:hover,&:focus': {
        backgroundColor: colors.primary,
        color: colors.white,
    },
});

export const remarkInput = css({
    marginTop: 10,
    width: 250,
});
